import { Col } from 'antd';
import styled from 'styled-components';

export default styled(Col)`
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  #simulation-chart {
    margin-top: 24px;
    padding: 16px;
    background-color: ${({ theme }) => theme.colors.light} !important;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    height: 470px;
  }
  .steps {
    width: 70%;
    display: flex;
    align-items: center;
    gap: 50px;
  }

  .hidden-content {
    .ant-card {
      width: 100% !important;
      height: auto !important;
      margin-top: 0px !important;
      .ant-card-body {
        .column {
          //analysis table style
          .ant-typography {
            padding-left: 12px;
          }
        }
      }
    }
    .ant-table-thead tr > th {
      padding: 2px 4px !important;
    }
    .ant-table-wrapper .ant-table-tbody > tr > td {
      padding: 2px 4px !important;
    }
  }

  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;

    .btn-next {
      width: 90px;
      height: 32px;
      margin-left: 8px;
    }
    .btn-cancel {
      width: 72px;
      height: 32px;
      color: ${({ theme }) => theme.colors.blueLightMedium};
      border-color: ${({ theme }) => theme.colors.blueLightMedium};
    }
    .btn-back {
      width: 83px;
      height: 32px;
      color: ${({ theme }) => theme.colors.blueLightMedium};
      border-color: ${({ theme }) => theme.colors.blueLightMedium};
    }
    .bottom-button-group {
      position: fixed;
      width: 85%;
      bottom: 0;
      right: 0;
      background: white;
      padding: 24px;
      box-shadow: 0 -5px 5px -5px rgba(0, 0, 0, 0.1);
      z-index: 10;
    }
  }

  .current-card {
    min-height: 200px;
    height: calc(100vh - 283px);
    overflow: auto;
  }

  .ant-form-item .ant-form-item-label > label {
    color: ${({ theme }) => theme.colors.dark} !important;
  }
  .ant-collapse-expand-icon {
    height: 40px !important;
    padding-inline-end: 10.5px !important;
    span > svg {
      width: 18px;
      height: 18px;
    }
  }
  .ant-collapse-extra {
    display: flex;
    align-items: center;
    height: 40px;
    span {
      display: flex;
      align-items: center;
      height: 28px;
      div > span {
        display: flex;
        align-items: center;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 21px !important;
      }
    }
  }
  .ant-steps-item-title {
    display: flex;
    align-items: center;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 21px !important;
    height: 32px !important;
    padding-inline-end: 8px !important;
  }

  .ant-steps-label-horizontal > .ant-steps-item {
    flex: none !important;
  }
  .ant-steps-label-horizontal > .ant-steps-item {
    flex: none;
    .ant-steps-item-container {
      width: 220px !important;
    }
  }
  .ant-steps-label-horizontal .ant-steps-item:nth-child(2) > div {
    width: 190px !important;
  }
  .ant-steps-label-horizontal > .ant-steps-item:nth-child(n + 2) {
    padding-inline-start: 8px !important;
  }
  .ant-steps-item-icon {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .ant-steps-icon > span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-steps-item-active {
    .ant-steps-item-icon {
      background-color: ${({ theme }) => theme.colors.bluePrimary} !important;
      .ant-steps-icon {
        color: ${({ theme }) => theme.colors.light} !important;
      }
    }
  }
  ul.ant-pagination.ant-pagination-mini.ant-table-pagination.ant-table-pagination-right {
    margin-right: 16px;
  }
  tr.ant-table-measure-row {
    display: none;
  }
  .recharts-default-legend {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 30px;
    li {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      gap: 4px !important;
      svg {
        margin: 0 !important;
      }
    }
  }
  .hidden-container {
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 100%;
    height: auto;
    opacity: 0.01;
    pointer-events: none;
    overflow: hidden;
  }
  .energy-market {
    .recharts-default-legend {
      margin-top: 9px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      gap: 30px;
      li {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 0 !important;
        gap: 8px !important;
        svg {
          margin: 0 !important;
        }
      }
    }
    li.recharts-legend-item.legend-item-4 {
      position: absolute;
      rotate: 90deg;
      top: -328px;
      right: -45px;
      svg.recharts-surface {
        rotate: 90deg;
      }
    }
    li.recharts-legend-item.legend-item-5 {
      position: absolute;
      rotate: 90deg;
      top: -208px;
      right: -54px;
      svg.recharts-surface {
        rotate: 90deg;
      }
    }
    li.recharts-legend-item.legend-item-6 {
      position: absolute;
      rotate: 90deg;
      top: -80px;
      right: -53px;
      svg.recharts-surface {
        rotate: 90deg;
      }
    }

    &.pdf-capture {
      li.recharts-legend-item.legend-item-4,
      li.recharts-legend-item.legend-item-5,
      li.recharts-legend-item.legend-item-6 {
        position: static !important;
        transform: none !important;
        rotate: none !important;
        display: inline-flex !important;
        margin: 0 15px !important;

        svg.recharts-surface {
          transform: none !important;
          rotate: none !important;
        }
      }

      .recharts-default-legend {
        flex-wrap: wrap !important;
        max-width: 100% !important;
        gap: 15px !important;
      }
    }
  }
  .recharts-tooltip-wrapper {
    border: 1px solid ${({ theme }) => theme.colors.grayAccent};
    border-radius: 8px;
  }
  .parameters {
    .tags {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 3.5px 7px;
      border-radius: 4px;
      border: 0.5px solid ${({ theme }) => theme.colors.blueLightMedium};
      background-color: transparent;
      color: ${({ theme }) => theme.colors.dark};
      cursor: pointer;
      &:hover {
        background-color: ${({ theme }) => theme.colors.blueLightMedium};
        color: ${({ theme }) => theme.colors.light};
      }
    }
  }
  .create-report {
    .report-modal {
      .ant-modal-content {
        background: rgba(255, 255, 255, 0.15) !important;
        border-radius: 24px;
        box-shadow: 0 8px 32px 0 rgba(62, 138, 198, 0.5);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border: 1px solid rgba(255, 255, 255, 0.18);
        padding: 0;
        overflow: hidden;
        position: relative;
      }
      .ant-modal-content::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.05) 100%
        );
        pointer-events: none;
      }
      .ant-modal-body {
        padding: 56px 40px 48px 40px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        z-index: 1;
      }
      .loading-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0;
      }
      .spinner-container {
        margin-bottom: 24px;
        position: relative;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        &::before,
        &::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          border: 4px solid transparent;
          border-top-color: ${({ theme }) => theme.colors.light};
          animation: spin 1.5s linear infinite;
        }
        &::before {
          width: 60px;
          height: 60px;
          border-width: 6px;
          animation-duration: 1.8s;
        }
        &::after {
          width: 80px;
          height: 80px;
          border-width: 4px;
          animation-duration: 1.2s;
          opacity: 0.7;
        }
      }
      .loading-title {
        color: ${({ theme }) => theme.colors.light};
        font-size: 2.2rem;
        font-weight: 700;
        margin-bottom: 12px;
        letter-spacing: 0.5px;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        background: linear-gradient(
          45deg,
          ${({ theme }) => theme.colors.light},
          #e0f7fa
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      .loading-description {
        color: rgba(255, 255, 255, 0.9);
        font-size: 1.1rem;
        margin-bottom: 12px;
        font-weight: 400;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      }

      .background-warning {
        color: ${({ theme }) => theme.colors.alertWarning};
        font-size: 14px;
        font-weight: 500;
        margin-top: 24px;
        padding: 12px 16px;
        background: rgba(255, 215, 0, 0.15);
        border-radius: 10px;
        border: 1px solid rgba(255, 215, 0, 0.3);
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      }
    }
    .ant-modal-mask {
      background: rgba(10, 18, 32, 0.85) !important;
      backdrop-filter: blur(8px);
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }
  .ant-upload-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ant-upload-list-item {
    height: 32px !important;
    margin: 0 !important;
  }
  .ant-spin-dot-holder {
    color: ${({ theme }) => theme.colors.light} !important;
  }
`;
